module.exports = __webpack_public_path__ + "static/img/manual-17.e3ce948.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-17.png
// module id = zUi/
// module chunks = 4